import Skeleton from '../skeleton/Skeleton';
import { StyledThreadListItem } from './Unibox.styles';

/** One thread row's shape. Kept apart from ThreadListItem so the page skeleton stays light. */
const ThreadListItemSkeleton = () => (
  <StyledThreadListItem as="div" disabled>
    <div className="thread-row-top">
      <Skeleton width={32} height={32} />
      <div className="thread-main" style={{ flex: 1 }}>
        <Skeleton width="80%" height={14} margin="0 0 6px" />
        <Skeleton width="60%" height={12} margin="0 0 8px" />
        <Skeleton width="100%" height={28} />
      </div>
    </div>
  </StyledThreadListItem>
);

export default ThreadListItemSkeleton;
